import { StrictMode } from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import { PreloadedDataProvider } from './PreloadedDataContext'

const root = document.getElementById('root')!
const preloadedData = window.__PRELOADED_DATA__ ?? null
const app = (
  <StrictMode>
    <PreloadedDataProvider value={preloadedData}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PreloadedDataProvider>
  </StrictMode>
)

const normalizePath = (path: string) => path.length > 1 ? path.replace(/\/+$/, '') : path
const prerenderedRoute = root.dataset.prerenderRoute
const routeMatchesPrerender = prerenderedRoute
  ? normalizePath(prerenderedRoute) === normalizePath(window.location.pathname)
  : false

if (root.innerHTML.trim() && routeMatchesPrerender) {
  hydrateRoot(root, app)
} else {
  root.innerHTML = ''
  createRoot(root).render(app)
}
